import { VpButton } from '@vtmn-play/react'
import Modal from 'components/common/mygame/modal/modal'
import {
  HOME_NO_DATA,
  HOME_NO_USER_PREFERENCES_CONTINUE,
  HOME_NO_USER_PREFERENCES_STORE
} from 'core/constants/translations/home'
import { getPathFromRouteId } from 'core/utils/route-utils'
import { RouteId } from 'core/routing/router/route-ids'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

const HomeNoStore = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const continueToUserPreferences = () => {
    const path = getPathFromRouteId(RouteId.UserPreferences)
    void navigate(path)
  }

  return (
    <div data-testid="home-no-store" className="mg-homepage-no-store">
      <Modal
        open
        title={t(HOME_NO_DATA)}
        footer={
          <VpButton
            data-testid="home-no-store-continue-button"
            variant="primary"
            variantStyle="regular"
            size="medium"
            onClick={continueToUserPreferences}
          >
            {t(HOME_NO_USER_PREFERENCES_CONTINUE)}
          </VpButton>
        }
      >
        <p data-testid="home-no-store-content" className="mg-homepage-no-store-content vp-body-l">
          {t(HOME_NO_USER_PREFERENCES_STORE)}
        </p>
      </Modal>
    </div>
  )
}

export default HomeNoStore
